class User {
	id = null;
	first_name = '';
	last_name = '';
	email = '';
	phone = null;
	password = '';
	confirmPassword = '';
	offices = [];
	active = true;
	locked = false;
	user_role_id = 2;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default User;
